import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';

import BigIcon from 'UI/atoms/BigIcon';
import CardContent from 'UI/atoms/CardContent';
import Title from 'UI/atoms/Title';
import Subtitle from 'UI/atoms/Subtitle';
import { useParams, useNavigate } from 'react-router-dom';
import { validateUser } from 'services/validateUser';
import { getActivity } from 'services/getActivity';
import Loader from './../../UI/atoms/Loader/index';

import warning from 'assets/img/icon/warning.png';

const RegisterValidation = () => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const [registerValid, setRegisterValid] = useState(true);
  const { code, activityId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const queries = [];
    queries.push(validateUser(code));
    if (activityId) {
      const activityParams = activityId.split('-');
      queries.push(getActivity(activityParams[0]));
    }
    Promise.all(queries).then((results) => {
      navigate(`/${locale}/register-finished`, { state: { data: results, activityId } });
    }).catch(() => {
      setRegisterValid(false);
    });
  }, []);

  if (!registerValid) {
    return (<>
      <CardContent sm={{ span: 10, offset: 1 }}>
        <BigIcon src={warning} />
        <Title>{t('register.already_completed.title')}</Title>
        <Row>
          <Col xs={12} sm={{ span: 12, offset: 0 }}>
            <Subtitle>
              <span dangerouslySetInnerHTML={{ __html: t('register.already_completed.subtitle') }}></span>
            </Subtitle>
          </Col>
        </Row>
      </CardContent>
    </>);
  }

  return (<CardContent sm={{ span: 10, offset: 1 }}>
    <Loader position="relative" size="big" color="green" />
    <Subtitle>{t('register_validation.loading_validation')}</Subtitle>
  </CardContent>);
};

export default RegisterValidation;
